import React from 'react';
import { AuthService } from '../components/auth/AuthService';

interface SignInProps {
  onAuthSuccess?: () => void;
}

export const SignIn: React.FC<SignInProps> = ({ onAuthSuccess }) => {
  const handleAuthChange = (user: any) => {
    if (user && onAuthSuccess) {
      onAuthSuccess();
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center">
      <div className="max-w-md w-full mx-auto px-4">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <img
              src="/brand/icon-mark.svg"
              alt="SmartCatalog"
              className="h-16 mx-auto mb-6"
            />
            <h1 className="text-3xl font-bold text-slate-900 mb-3">
              Sign in to SmartCatalog
            </h1>
            <p className="text-slate-500 text-lg">
              Access your product catalog
            </p>
          </div>

          <div className="space-y-4">
            <AuthService
              variant="card"
              onAuthChange={handleAuthChange}
              showUserInfo={false}
              size="lg"
            />

            <div className="pt-4 border-t border-gray-200">
              <p className="text-sm text-center text-gray-500">
                Secure authentication powered by Google
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};